import {Layout} from 'react-admin';
import React from 'react';
import SenderAppBar from './SenderAppBar';

const SenderLayout = props => <Layout {...props} appBar={SenderAppBar}/>;

export default SenderLayout;